"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMortgageInputs = void 0;
exports.toMortgageInputs = function (state) {
    var propertyValue = state.calcPriceValue;
    var interestRate = state.calcRateValue;
    var downPayment = state.calcPriceValue * (1000 - state.calcLoanPercentValue) / 1000;
    var adValoremStampDuty = state.calcOwnProp;
    var adValoremStampDutyRate = state.calcAdValoremStampDutyRate;
    var buyerStampDuty = !state.calcHkBuyer;
    var buyerStampDutyRate = state.calcBuyerStampDutyRate;
    var commissionRate = state.calcCommissionRate;
    var lastTransactionInMonth = -1;
    var doubleAdValoremStampDutyRateTable = state.calcDoubleAdValoremStampDutyRateTable;
    var specialStampDutyRateTable = state.calcSpecialStampDutyRateTable;
    var tenor = state.calcTenorValue;
    var mortgagePlanList = state.calcmortgageInsuranceSetting;
    var mortgageLimitTable = state.calcMortgageLimit;
    var isInsuranceMonthlyRepay = true;
    var legalAmount = state.calcLegalAmount;
    var rateTableInputs = state.calcRateTableInputs;
    return {
        propertyValue: propertyValue,
        downPayment: downPayment,
        tenor: tenor,
        interestRate: interestRate,
        buyerStampDuty: buyerStampDuty,
        adValoremStampDuty: adValoremStampDuty,
        lastTransactionInMonth: lastTransactionInMonth,
        commissionRate: commissionRate,
        buyerStampDutyRate: buyerStampDutyRate,
        adValoremStampDutyRate: adValoremStampDutyRate,
        specialStampDutyRateTable: specialStampDutyRateTable,
        doubleAdValoremStampDutyRateTable: doubleAdValoremStampDutyRateTable,
        mortgagePlanList: mortgagePlanList,
        mortgageLimitTable: mortgageLimitTable,
        isInsuranceMonthlyRepay: isInsuranceMonthlyRepay,
        legalAmount: legalAmount,
        rateTableInputs: rateTableInputs
    };
};
